const _PROGRAM_CONSTANTS = {
  RBT: {
    name: "RBT",
    title: "BlueGive",
    primaryColor: "#001489",
    secondaryColor: "#009CDE",
  },
  TG: {
    name: "TG",
    title: "TIFIN Give",
    primaryColor: "#3959DE",
    secondaryColor: "#151f4b",
  },
  AMK: {
    name: "AMK",
    title: "Assetmark Charitable",
    primaryColor: "#4BADD2",
    secondaryColor: "#044E7B",
  },
  MSW: {
    name: "MSW",
    title: "Morgan Stanley At Work",
    primaryColor: "#187aba",
    secondaryColor: "#f2f4f7",
  },
  default: {
    name: "default",
    title: "TIFIN Give",
    primaryColor: "#3959DE",
    secondaryColor: "#151f4b",
  },
};

const getProgramConstants = (programName: string) => {
  const program =
    _PROGRAM_CONSTANTS[programName as keyof typeof _PROGRAM_CONSTANTS];
  if (!program) {
    return _PROGRAM_CONSTANTS.default;
  }
  return program;
};

export const getCurrentProgramName = (): string => {
  return process.env.NEXT_PROGRAM_NAME ?? "TG";
};

/**
 * The program's default platform name (e.g. "TIFIN Give", "BlueGive",
 * "Assetmark Charitable"). Firms rebrand within a program, so user-facing copy
 * should use resolvePlatformName / usePlatformName, which prefer the firm's own
 * branding and fall back to this.
 */
export const getPlatformName = (): string =>
  getProgramConstants(getCurrentProgramName()).title;

export const isRBTProgram = (): boolean => {
  return getCurrentProgramName() === "RBT";
};

export const isTGProgram = (): boolean => {
  return getCurrentProgramName() === "TG";
};

export const isAMKProgram = (): boolean => {
  return getCurrentProgramName() === "AMK";
};

export const isMSWProgram = (): boolean => {
  return getCurrentProgramName() === "MSW";
};

export const isUnattestedContributionsEnabled = (): boolean => {
  return isAMKProgram() || isTGProgram() || isRBTProgram();
};

export { getProgramConstants };
